import http from './default'

export default class MergeService {
  static async merge(masterProfileId, duplicateProfileIds) {
    const api = process.env.REACT_APP_SESSION_SERVICE_URL
    const params = {
      duplicateProfileIds: duplicateProfileIds.map(el => Number(el)),
      masterProfileId: Number(masterProfileId),
    }
    return await http.post(`${api}/profile/mergeDirect`, params)
  }
}
